import { CdnSettings } from './AemConfigurationTypes';
import { DeliveryPromiseExplanations } from './product-detail';
import { ProductLister } from './product-lister';

export enum SlideType {
  CATEGORY_TILE = 'category-tile',
  TEASER = 'teaser',
  SINGLE_PRODUCT_TILE = 'single-product-tile',
  CONTENT_TILE = 'content-tile',
  VIDEO = 'video',
}

export type Slide = {
  products?: Array<{ productCode: string; productColor: string }>;
  initializationProduct?: ProductLister;
  uniqueId?: string;
  type: SlideType;
  deliveryPromiseExplanations?: DeliveryPromiseExplanations;
};

export type SliderProperties = {
  cdnSettings?: CdnSettings;
  height?: {
    desktop?: number;
    mobile?: number;
    tablet?: number;
  };
  properties: {
    autoplay?: {
      delay: number;
      stopOnLastSlide: boolean;
    };
    displayCroppedSlides: boolean;
    hideOnViewports: boolean;
    infiniteSliding: boolean;
    innerSpacing: boolean;
    showArrowsForDesktop: boolean;
    showIndicators: boolean;
    slidesToScrollDesktop: number;
    slidesToScrollDesktopLarge: number;
    slidesToScrollMobile: number;
    slidesToScrollMobileLarge: number;
    slidesToScrollTablet: number;
    slidesToScrollTabletSmall: number;
    slidesToShowDesktop: number;
    slidesToShowDesktopLarge: number;
    slidesToShowMobile: number;
    slidesToShowMobileLarge: number;
    slidesToShowTablet: number;
    slidesToShowTabletSmall: number;
  };
  slides: Array<Slide>;
};
